//extracted by mini-css-extract-plugin
export default {"faqQuestion":"styles_faqQuestion__uaaEC","faqQuestionText":"styles_faqQuestionText__ZEqFO","bodyText":"styles_bodyText__vUUd0"};;